module.exports = __webpack_public_path__ + "img/nav04.2d4407da.png";